import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyCommentModule } from '@vendasta/galaxy/comment';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MarkdownModule } from 'ngx-markdown';
import { AskQuestionDialogComponent } from './ask-question-dialog/ask-question-dialog.component';
import { CharacterCountPipe } from './ask-question-dialog/character-count.pipe';
import baseTranslation from './assets/i18n/en_devel.json';
import { FulfillmentTrackerComponent } from './fulfillment-tracker/fulfillment-tracker.component';
import { FulfillmentSubtasksComponent } from './fulfillment-tracker/subtasks/fulfillment-subtasks.component';
import { ProjectCommentsComponent } from './project-comments/project-comments.component';
import { ProjectCommentsInputDirective } from './project-comments/project-comments.directives';
import { ProjectTrackerCommentsComponent } from './project-tracker-comments/project-tracker-comments.component';
import { ProjectTrackerSidenavContainerComponent } from './project-tracker-sidenav-container.component';

import { ProjectTrackerComponent } from './project-tracker.component';
import { CumulativeProgressBarComponent } from './shared/cumulative-progress-bar/cumulative-progress-bar.component';
import { HydrateNamePipe } from './shared/pipes/hydrate-name.pipe';
import { NameInitialsPipe } from './shared/pipes/name-initials.pipe';
import { ProjectsAndSubtasksByProductsService } from './shared/services/projects-and-subtasks-by-products.service';
import { TrackerSubtasksComponent } from './shared/tracker-subtasks/tracker-subtasks.component';
import { SimpleProjectTrackerComponent } from './simple-project-tracker/simple-project-tracker.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { MatListModule } from '@angular/material/list';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { SubtasksUploaderComponent } from './fulfillment-tracker/subtasks/subtasks-uploader/subtasks-uploader.component';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import {
  CanDeleteFilePipe,
  FilterAndSortFulfillmentFiles,
  UploadedByPipe,
} from './fulfillment-tracker/subtasks/fulfillment-subtasks.pipes';

@NgModule({
  declarations: [
    ProjectTrackerComponent,
    AskQuestionDialogComponent,
    CharacterCountPipe,
    TrackerSubtasksComponent,
    SimpleProjectTrackerComponent,
    CumulativeProgressBarComponent,
    ProjectTrackerSidenavContainerComponent,
    ProjectTrackerCommentsComponent,
    ProjectCommentsComponent,
    HydrateNamePipe,
    NameInitialsPipe,
    ProjectCommentsInputDirective,
    FulfillmentTrackerComponent,
    FulfillmentSubtasksComponent,
  ],
  exports: [
    ProjectTrackerComponent,
    AskQuestionDialogComponent,
    SimpleProjectTrackerComponent,
    CumulativeProgressBarComponent,
    ProjectTrackerSidenavContainerComponent,
    ProjectTrackerCommentsComponent,
    ProjectCommentsComponent,
    ProjectCommentsInputDirective,
    FulfillmentTrackerComponent,
  ],
  providers: [ProjectsAndSubtasksByProductsService],
  imports: [
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    MarkdownModule.forRoot(),
    MatButtonModule,
    MatInputModule,
    VaFormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatSlideToggleModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/project-tracker',
      baseTranslation: baseTranslation,
    }),
    GalaxyPageModule,
    GalaxyTooltipModule,
    GalaxyCommentModule,
    GalaxyBadgeModule,
    MatCheckboxModule,
    GalaxyAvatarModule,
    GalaxyFormFieldModule,
    GalaxyUploaderModule,
    MatListModule,
    GalaxyLoadingSpinnerModule,
    SubtasksUploaderComponent,
    GalaxyButtonLoadingIndicatorModule,
    UploadedByPipe,
    CanDeleteFilePipe,
    FilterAndSortFulfillmentFiles,
  ],
})
export class ProjectTrackerModule {}
